import { Button, ConfigProvider, Flex, Radio, Segmented, Tag, Typography } from "antd";
import ConsFilterFleet from "./ConsFilterFleet";
import RotFilterFleet from "./RotFilterFleet";
import { useSelector, useDispatch } from "react-redux";
import { setPartType } from "../redux/partsSlice";
import ConsFilterGroup from "./ConsFilterGroup";
import RotFilterGroup from "./RotFilterGroup";

export const FilterComponent = () => {
    const selectParts = useSelector(state => state.partTypeState.partType);
    const dispatch = useDispatch();
    const { Text } = Typography;

    const changeTag = (val, checked) => {
     //   const nextSelectedTags = checked
     //   ? val
     //   : selectParts != val;
        const nextSelectedTags = val;
        const setTagsAction =  setPartType(nextSelectedTags);
        dispatch(setTagsAction);     
    }

    return (
                (selectParts==="Consumable")?
                <Flex vertical style={{flex:1, gap:40, paddingLeft:50, paddingBottom:30, justifyContent: 'flex-start'}}>                    
                    <ConsFilterGroup/>
                </Flex>
                :                
                <Flex vertical style={{flex:1, gap:40, paddingLeft:50, paddingBottom:30, justifyContent: 'flex-start'}}>                    
                    <RotFilterGroup/>
                </Flex>            
    )
}